import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export function Layout() {
  const loc = useLocation();
  // Reader gets the full viewport with no outer chrome padding.
  const isReader = loc.pathname.startsWith("/reader/");
  // Agent 3 embeds a live browser next to the chat — it needs the full width.
  // Print search runs filters | results | article side by side — it needs the width too.
  const isWide = loc.pathname.startsWith("/agent3") || loc.pathname.startsWith("/print-search");

  return (
    <div className="flex h-screen w-screen overflow-hidden paper-grain">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar />
        <main className="flex-1 overflow-hidden">
          {isReader ? (
            <Outlet />
          ) : (
            <div className="h-full overflow-y-auto">
              <div className={isWide ? "px-4 py-4" : "mx-auto max-w-7xl px-6 md:px-10 py-8"}>
                <Outlet />
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
